import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@ui-nuvertos/shared';

export interface ClientFilters {
  type?: 'all' | 'draft' | 'non-draft';
  limit?: number;
  offset?: number;
  client_name?: string;
  phone?: string;
  category?: string;
  created_at?: string;
  referred_by?: string;
  is_deleted?: boolean;
}

export interface ClientApiResponse {
  data: {
    total: number;
    clients: any[];
    limit?: number;
    offset?: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ClientListService {
  private readonly API_BASE_URL = environment.accountingUrl;

  constructor(private http: HttpClient) {}

  getClients(filters?: ClientFilters): Observable<ClientApiResponse> {
    let params = new HttpParams().set('type', filters?.type ?? 'all');

    if (filters?.limit !== undefined) {
      params = params.set('limit', String(filters.limit));
    }

    if (filters?.offset !== undefined) {
      params = params.set('offset', String(filters.offset));
    }

    if (filters?.client_name?.trim()) {
      params = params.set('client_name', filters.client_name.trim());
    }

    if (filters?.phone?.trim()) {
      params = params.set('phone', filters.phone.trim());
    }

    if (filters?.category?.trim()) {
      params = params.set('category', filters.category.trim());
    }

    if (filters?.created_at) {
      params = params.set('created_at', filters.created_at);
    }

    if (filters?.referred_by?.trim()) {
      params = params.set('referred_by', filters.referred_by.trim());
    }

    if (filters?.is_deleted !== undefined) {
      params = params.set('is_deleted', String(filters.is_deleted));
    }

    return this.http.get<ClientApiResponse>(`${this.API_BASE_URL}/api/v1/clients`, {
      params,
      withCredentials: true,
    });
  }

  getClientById(clientId: string | number, filters?: { include_subsidiary?: string }): Observable<any> {
    let params = new HttpParams();
    
    if (filters?.include_subsidiary) {
      params = params.set('include_subsidiary', filters.include_subsidiary);
    }

    return this.http.get<any>(`${this.API_BASE_URL}/api/v1/clients/${clientId}`, {
      params,
      withCredentials: true,
    });
  }

  deleteClient(clientId: string | number): Observable<void> {
    return this.http.delete<void>(`${this.API_BASE_URL}/api/v1/clients/${clientId}`, {
      withCredentials: true,
    });
  }
}

